module.exports = __webpack_public_path__ + "img/ico_search.9df51d4e.svg";